import { useTranslation } from "react-i18next";
import TextInput from "../../inputs/textInput";

const Step4Form = ({ formik }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">

      {/* Commercial Register */}
      <div className="relative">
        <label>{t("commercialRegisterCopy")}</label>

        <input
          type="file"
          className="w-full p-2 border rounded"
          onChange={(e) =>
            formik.setFieldValue(
              "commercialRegisterCopy",
              e.currentTarget.files[0]
            )
          }
        />

        {formik.touched.commercialRegisterCopy &&
          formik.errors.commercialRegisterCopy && (
            <span className="text-[12px] text-red-500 absolute bottom-[-16px]">
              {formik.errors.commercialRegisterCopy}
            </span>
          )}
      </div>

      {/* License */}
      <div className="relative">
        <label>{t("professionalLicenseCopy")}</label>

        <input
          type="file"
          className="w-full p-2 border rounded"
          onChange={(e) =>
            formik.setFieldValue(
              "professionalLicenseCopy",
              e.currentTarget.files[0]
            )
          }
        />

        {formik.touched.professionalLicenseCopy &&
          formik.errors.professionalLicenseCopy && (
            <span className="text-[12px] text-red-500 absolute bottom-[-16px]">
              {formik.errors.professionalLicenseCopy}
            </span>
          )}
      </div>

      {/* VAT (لو موجود عندك في الفورم) */}
      <div className="relative">
        <label>{t("VatIfExist")}</label>

        <input
          type="file"
          className="w-full p-2 border rounded"
          onChange={(e) =>
            formik.setFieldValue(
              "vatIfExist",
              e.currentTarget.files[0]
            )
          }
        />

        {formik.touched.vatIfExist && formik.errors.vatIfExist && (
          <span className="text-[12px] text-red-500 absolute bottom-[-16px]">
            {formik.errors.vatIfExist}
          </span>
        )}
      </div>

      {/* Other Docs */}
      <div className="relative">
        <label>{t("otherSupportiveDocuments")}</label>

        <input
          type="file"
          className="w-full p-2 border rounded"
          onChange={(e) =>
            formik.setFieldValue(
              "otherSupportiveDocuments",
              e.currentTarget.files[0]
            )
          }
        />

        {formik.touched.otherSupportiveDocuments &&
          formik.errors.otherSupportiveDocuments && (
            <span className="text-[12px] text-red-500 absolute bottom-[-16px]">
              {formik.errors.otherSupportiveDocuments}
            </span>
          )}
      </div>

      {/* Checkbox */}
      <label
        htmlFor="iCertify"
        className="flex items-center gap-2"
        style={{
          color:
            formik.touched.iCertify && formik.errors.iCertify
              ? "red"
              : "inherit",
        }}
      >
        <input
          type="checkbox"
          id="iCertify"
          name="iCertify"
          checked={formik.values.iCertify}
          onChange={formik.handleChange}
        />
        {t("iCertify")}
      </label>

      {/* Applicant Name */}
      <TextInput
        formik={formik}
        placeholder={t("applicantName")}
        label={t("applicantName")}
        name="applicantName"
      />

      <p>{t("noteUCanSendFiles")}</p>
    </div>
  );
};

export default Step4Form;